import React from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
function TradeHubLive() {
  return (
    <div className="bg-light py-4">

      <Container>

        {/* TITLE */}
        <h2 className="text-center mb-3">TRADE HUB</h2>
        <p className="text-center text-muted mb-4">
       Purchasing, Sales, and Inventory Management Software
        </p>

        {/* 3 COLUMN LAYOUT */}
        <Row className="g-4">

          {/* ADMIN LOGIN */}
          <Col md={4}>
            <Card className="shadow-sm h-100">
              <Card.Body>
       <Button variant="primary" className="w-100">
                  Admin Login
                  </Button>
                <Form>
                  <Form.Group className="mb-2">
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" value="alphonso2009@gmail.com" readOnly />
                  </Form.Group>

                  

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="text" value="alpha@123" readOnly />
                  </Form.Group>

                 
                </Form>

              </Card.Body>
            </Card>
          </Col>

          {/* ATTENDANT LOGIN */}
          <Col md={4}>
            <Card className="shadow-sm h-100">
              <Card.Body>

               <Button variant="success" className="w-100">
                    Cashier Login
                  </Button>
                <Form>
                  <Form.Group className="mb-2">
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" value="maggie@gmail.com" readOnly />
                  </Form.Group>

                

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="text" value="maggie" readOnly />
                  </Form.Group>

                 
                </Form>

              </Card.Body>
            </Card>
          </Col>

          {/* SYSTEM INFO */}
          <Col md={4}>
            <Card className="shadow-sm h-100">
              <Card.Body>

                <h5 className="text-center mb-3">How It Works</h5>

             <p>TRADE HUB helps businesses manage buying, selling, and stock automatically so they always know what items are available.</p>

                <p className="text-muted small">
                 This system manages the inventory , purchasing and selling management system. 
                </p>

              </Card.Body>
            </Card>
          </Col>

        </Row>

        {/* LIVE DEMO BUTTON */}
        <div className="text-center mt-4">
          <a
            href="https://tradehub.chrisalphatech.com/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button size="lg"
              style={{
                backgroundColor: "#0d6efd",
                border: "none"
              }}>
               Open Live Demo
            </Button>
          </a>
         
               <Link 
                  to="/tradehub" 
                 style={{ 
          color: "#0d6eff", 
          fontWeight: "500",
          marginLeft: "20px"
        }}
                >
                  Read More 
                </Link>
                
                
        </div>
     

      </Container>

    </div>
  );
}

export default TradeHubLive;